(() => {
  const clickAndCollectDialog = document.querySelector(".js-click-and-collect__dialog");
  const dialogOpenButton = document.querySelector(".js-click-and-collect__button");
  const dialogCloseButton = document.querySelector(".js-click-and-collect__close-button");

  dialogOpenButton.addEventListener("click", function pickUpOpener(e) {
    clickAndCollectDialog.showModal();
  });

  dialogCloseButton.addEventListener("click", (e) => {
    clickAndCollectDialog.close();
  });

  clickAndCollectDialog.addEventListener("click", (e) => {
    const dialogDimensions = clickAndCollectDialog.getBoundingClientRect();
    if (
      e.clientX < dialogDimensions.left ||
      e.clientX > dialogDimensions.right ||
      e.clientY < dialogDimensions.top ||
      e.clientY > dialogDimensions.bottom
    ) {
      clickAndCollectDialog.close();
    }
  });
})();
